import { useEffect, useState } from 'react';

export const useGetTheme = () => {
    const [theme, setTheme] = useState<string>('system');
    useEffect(() => {
        setTheme(
            document.documentElement.getAttribute('data-theme') ?? 'system'
        );
    }, [document.documentElement]);

    return theme;
};
